import React from 'react';

function Contact() {
    return (
        <section className="contact-section">
            <div className="content-area clearfix">
                <div className="contact-info-col">
                    <div className="contact-info">
                        <ul>
                            <li>
                                <i className="fi flaticon-home-3"></i>
                                <h4>Head Office</h4>
                                <p>54, Dahs udin sorok, Melborn Austria</p>
                            </li>
                            <li>
                                <i className="fi flaticon-email"></i>
                                <h4>Email Address</h4>
                                <p>demo@example.com</p>
                            </li>
                            <li>
                                <i className="fi flaticon-support"></i>
                                <h4>Telephone</h4>
                                <p>654756175+5474</p>
                            </li>
                            <li>
                                <i className="fi flaticon-clock"></i>
                                <h4>Office Hour</h4>
                                <p>Mon-Sun: 10am – 7pm</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="contact-form-col">
                    <div className="section-title-s2">
                        <div className="icon">
                            <i className="fi flaticon-balance"></i>
                        </div>
                        <span>Contact form</span>
                        <h2>Need Consultancy, <br />Request A Free Quote</h2>
                        <p>Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nuncIt showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy</p>
                    </div>
                    <div className="contact-form">
                        <form method="post" className="contact-validation-active" id="contact-form-main">
                            <div>
                                <input type="text" className="form-control" name="name" id="name" placeholder="Name*" />
                            </div>
                            <div>
                                <input type="email" className="form-control" name="email" id="email" placeholder="Email*" />
                            </div>
                            <div>
                                <input type="text" className="form-control" name="phone" id="phone" placeholder="Phone*" />
                            </div>
                            <div>
                                <select name="subject" className="form-control" defaultValue="">
                                    <option value="" disabled>Contact subject</option>
                                    <option value="Subject 1">Subject 1</option>
                                    <option value="Subject 2">Subject 2</option>
                                    <option value="Subject 3">Subject 3</option>
                                </select>
                            </div>
                            <div className="fullwidth">
                                <textarea className="form-control" name="note" id="note" placeholder="Case Description..."></textarea>
                            </div>
                            <div className="submit-area">
                                <button type="submit" className="theme-btn-s3">Submit It Now</button>
                                <div id="loader">
                                    <i className="ti-reload"></i>
                                </div>
                            </div>
                            <div className="clearfix error-handling-messages">
                                <div id="success">Thank you</div>
                                <div id="error"> Error occurred while sending email. Please try again later. </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Contact;